import { create } from 'zustand';

interface DocHeaderState {
    hasDocHeader: boolean;
    setHasDocHeader: (hasDocHeader: boolean) => void;
}

/**
 * Lightweight coordinator store for Top Header Document Portal.
 * Signals to Header.tsx whether an active document view (e.g. StandardDetailLayout)
 * has attached its portal into #apv-header-portal-slot.
 */
export const useDocHeaderStore = create<DocHeaderState>((set) => ({
    hasDocHeader: false,
    setHasDocHeader: (hasDocHeader: boolean) => set({ hasDocHeader }),
}));
